<nav class="no-shadow">
  <ol class="breadcrumb">
    @if (superCategory || roadmapIndicator || investment) {
      <li class="breadcrumb-item" routerLinkActive="active">
        <a [routerLink]="superCategory ? '/insight/technical-state' : '/map'">
          <ng-container>{{
            'pages.insight.notations.title.by_secondary_kpi' | translate
          }}</ng-container>
        </a>
      </li>
    }
    @if (router.url.includes('/single-pages/') && !superCategory && !showSuperCategories) {
      <li class="breadcrumb-item" routerLinkActive="active">
        <a routerLink="/insight/technical-state">
          <fa-icon class="fa-lg" icon="home-alt"></fa-icon> {{ 'pages.insight.initiative.synthesis' | translate }}
        </a>
      </li>
    }

    @if (showSuperCategories) {
      <li class="breadcrumb-item" routerLinkActive="active">
        <a [routerLink]="['/insight/notations']"
          queryParamsHandling="merge">{{ 'pages.insight.notations.title.by_super_category' | translate }}
        </a>
      </li>
    }

    @if (superCategory) {
      <li class="breadcrumb-item" routerLinkActive="active">
        <a [routerLink]="category
            ? ['/insight/notations/super-category', superCategory.id, 'showCategories', 0]
            : ['/insight/notations/super-category', superCategory.id]"
        queryParamsHandling="merge">{{ superCategory.name }}</a>
      </li>
    }
    @if (superCategory && category) {
      <li class="breadcrumb-item" routerLinkActive="active">
        <a
        [routerLink]="[
          '/insight/notations/super-category',
          superCategory.id,
          'category',
          category.id
        ]"
          queryParamsHandling="merge"
          >{{ category.name }}</a
          >
        </li>
      }
      @if (category && !subCategory) {
        <li class="breadcrumb-item" routerLinkActive="active">
          {{ 'pages.insight.notations.title.by_sub_category' | translate }}
        </li>
      }
      @if (superCategory && category && subCategory) {
        <li class="breadcrumb-item" routerLinkActive="active">
      <a [routerLink]="[
          '/insight/notations/super-category',
          superCategory.id,
          'category',
          category.id,
          'sub-category',
          subCategory.id
        ]" queryParamsHandling="merge">{{ subCategory.name }}</a>
        </li>
      }
      @if (superCategory && category && subCategory && site) {
        <li class="breadcrumb-item" routerLinkActive="active">
      <a [routerLink]="[
          '/insight/notations/super-category',
          superCategory.id,
          'category',
          category.id,
          'sub-category',
          subCategory.id,
          'site',
          site.id
        ]" queryParamsHandling="merge">{{ site.name }}</a>
        </li>
      }
      @if (superCategory && category && subCategory && assetType) {
        <li class="breadcrumb-item" routerLinkActive="active">
      <a [routerLink]="[
          '/insight/notations/super-category',
          superCategory.id,
          'category',
          category.id,
          'sub-category',
          subCategory.id,
          'asset-type',
          assetType.id
        ]" queryParamsHandling="merge">{{ assetType.name }}</a>
        </li>
      }
      @if (investment) {
        <li class="breadcrumb-item" routerLinkActive="active">
          <a [routerLink]="['/insight/investments', investment.id]" queryParamsHandling="merge">{{ investment.label }}</a>
        </li>
      }
      @if (roadmapIndicator) {
        <li class="breadcrumb-item" routerLinkActive="active">
      <a [routerLink]="[
          '/insight/notations/roadmap-indicator',
          roadmapIndicator.id
        ]" queryParamsHandling="merge">{{ roadmapIndicator.name }}</a>
        </li>
      }
      @if (roadmapIndicator && chapter) {
        <li class="breadcrumb-item" routerLinkActive="active">
      <a [routerLink]="[
          '/insight/notations/roadmap-indicator',
          roadmapIndicator.id,
          'chapter',
          chapter.id
        ]" queryParamsHandling="merge">{{ chapter.subject }}</a>
        </li>
      }
      @if (roadmapIndicator && chapter && perimeter) {
        <li class="breadcrumb-item" routerLinkActive="active">
      <a [routerLink]="[
          '/insight/notations/roadmap-indicator',
          roadmapIndicator.id,
          'chapter',
          chapter.id,
          'perimeter',
          perimeter.id
        ]" queryParamsHandling="merge">{{ perimeter.name }}</a>
        </li>
      }

      @if (router.url.includes('/single-pages/investments')) {
        <li class="breadcrumb-item" routerLinkActive="active">
          {{ 'pages.insight.investment.investment_table' | translate }}
        </li>
      }
    </ol>
  </nav>
